<template>
  <!-- 订单详情 -->
  <div class="detail">
    <!-- title -->
    <headers :params="hraderP"></headers>
    <div class="detail-header">
      <p>项目信息</p>
      <p>{{list.startStatus | startStatus }}</p>
    </div>
    <div class="detai-list">
      <div class="detai-list-1">
        <p class="name">{{list.taskName}}</p>
        <p>项目佣金: <span class="red">¥{{list.charge}}</span></p>
        <p>项目业态:
          <span v-for="item in list.buildingType" :key="item.id">{{ item.name }}</span>
          <span v-for="item in list.secondBuildingTypeList" :key="item.id">/ {{ item.name }}</span>
        </p>
        <p class="list">施工系统:  <span v-for="item in list.systemList">{{item.name}}</span></p>
        <div class="detai-list-2">
          <div class="item">
            <p>项目阶段:</p>
            <p>{{list.projectStage | stageFilter}}</p>
          </div>
          <div class="item">
            <p>产品交付:</p>
            <p>{{list.putType | typeFilters}}</p>
          </div>
          <div class="item">
            <p>产品时间:</p>
            <p>{{list.deliverDay}}个工作日</p>
          </div>
          <div class="item">
            <p>项目地址:</p>
            <p>{{list.provinceName }} <span v-if="list.provinceName">-</span> {{ list.cityName }}</p>
          </div>
        </div>
      </div>
      <div  v-if="list.startStatus!==6">
        <div class="h12"></div>
        <div class="detai-list-3">
          <p class="number">定制方案合同</p>
          <div class="loadImg">
            <img src="../../assets/images/icon-wenjian.png" >
            <p>
              <a :href="list.contractUrl" target="_blank">河姆渡方案馆弱电智能化设计项目合同.pdf</a>
            </p>
          </div>
          <div class="detai-list-2" style="border: none;">
            <div class="item">
              <p>订单编号:</p>
              <p>{{list.orderNo}}</p>
            </div>
            <!-- <div class="item">
              <p>项目费用:</p>
              <p class="red"><span v-if="list.charge!==0">¥</span>{{list.charge}}</p>
            </div> -->
            <div v-if="list.startStatus!==1">
              <p class="tips">提示：请登录河姆渡 -方案馆网页端进行上传交付成果上</p>
              <p class="wite">网页地址：https://solution.homedo.com/</p>
            </div>
          </div>
        </div>
      </div>

      <div class="baojia" v-if="list.startStatus==1">
        <button type="button" class="rejust" @click="rejust()">拒绝接单</button>
        <button type="button" class="submit" @click="submit()">确认接单</button>
      </div>
     <!-- <div class="baojia">
        <button type="button" class="rejust" @click="rejust(list)">拒绝接单</button>
        <button type="button" class="submit" @click="submit(list)">确认接单</button>
      </div> -->
    </div>
    <router-link to="/index.html"><img src="../../assets/images/hjinexenter.png" alt="" class="to-index"></router-link>
  </div>
</template>

<script>
  import headers from '@/components/headerslf'
  import { getTaskdatai,updateDesigntask} from '@/api/designer/designer'
  import { getNeed } from '@/api/userPerson/userPerson'
  import { quoteStateFilter,stateFilter,stageFilter,typeFilters,startStatus } from '@/filters/status'
  import { Dialog } from 'vant'
  export default{
    components: {
      headers
    },
    data() {
      return {
        hraderP: {
          title: '订单详情',
          lefticon: true
        },
        show: false,
        id:'',
        reqId:'',
        list:[]
      }
    },
    created() {
      this.id = this.$route.query.id
      this.reqId = this.$route.query.reqId
      this.getdata();
    },
    filters:{
      stageFilter,typeFilters,startStatus
    },
    methods:{
      getdata(){
        getTaskdatai(this.id).then(res =>{
          console.log(res,'res11111');
          if(res.data.code == 200){
            this.list = res.data.data
            console.log(this.list);
          }
        })
        // console.log(this.reqId,'this.reqId');
        // getNeed(this.reqId).then(res => {
        //   console.log(res,1111111111111111);
        // })
      },
      showPopup(){
         this.show = true;
      },
      cancle(){
         this.show = false;
      },
      rejust(list){
        Dialog.confirm({
          title: '',
          message: '拒绝接单?'
        }).then(() => {
          let params ={
            taskId:this.id,
            status:6//1-待接单；2-设计中；3-待审核；4-待验收；5-已完成；6-已拒绝
          }
          updateDesigntask(params).then(res => {
            if(res.data.code==200){
              this.$toast.success('拒绝接单成功')
              setTimeout(() => {
                this.$router.push('/designer/quotationText.html')
              }, 1000)
            }
          })
        }).catch(() => {
          // 取消
        })
      },
      submit(list){
        Dialog.confirm({
          title: '',
          message: '确认接单?'
        }).then(() => {
          let params ={
            taskId:this.id,
            status:2//1-待接单；2-设计中；3-待审核；4-待验收；5-已完成；6-已拒绝
          }
          updateDesigntask(params).then(res => {
            if(res.data.code==200){
              this.$toast.success('接单成功')
              setTimeout(() => {
                this.$router.push('/designer/quotationText.html')
              }, 1000)
            }
          })
        }).catch(() => {
          // 取消
        })
      },
      goHT() {
         if($HMD$.rApi["ENV"]=='fat'){
           window.open("https://solution.fat.homedo.com/users/contract.html?id=".concat(this.orderNo));
         }else {
           window.open("https://solution.homedo.com/users/contract.html?id=".concat(this.orderNo));
         }
      },
    }
  }
</script>

<style lang="scss">
  .detail{
    .van-popup{
      border-radius: 8px;
    }
    .van-cell{
      background: #F7F8FA;
      margin-left: 5px;
      width: 80%;
    }
  }
</style>
<style lang="scss" scoped>
  .detail{
    background: #F6F6F6;
    .detail-header{
      height: 64px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      color:#fff;
      background-image: url(../../assets/images/back.png);
    }
    .detai-list{
      margin-top: -5px;
      .h12{
        height: 12px;
      }
      .detai-list-1{
        padding: 16px 16px 0 16px;
        background: #FFFFFF;
        border-radius: 10px 10px 0px 0px;
        p{
          margin-bottom: 16px;
        }
        .name{
          font-size: 15px;
          font-weight: bold;
          color: #222222;
          overflow: hidden;
          text-overflow: ellipsis;
          display: box;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .blue{
          color: #2F7BFF;
        }
        .red{
          color: #FF0000;
        }
        .list{
          span{
            display: inline-block;
            padding: 3px 6px;
            background: #EDF4FE;
            border-radius: 2px;
            border: 1px solid #9DC1FF;
            color: #2F7BFF;
            margin-right: 10px;
            margin-bottom: 10px;
          }
        }
      }
    }
    .detai-list-2{
      border-top: 1px dashed #ccc;
      padding-top: 20px;
      p{
        margin-bottom: 14px;
      }
      .item{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .red{
        color: #FF0000;
      }
      .tips{
        font-size: 12px;
        color: #999999;
      }
      .wite{
        color: #2E7BFF;
        padding-bottom: 16px;
      }
    }
    .detai-list-3{
      padding: 16px 16px 0 16px;
      background: #fff;
      .remark{
        padding-bottom: 10px;
      }
      .number{
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 20px;
      }
      .loadImg{
        display: flex;
        align-items: center;
        img{
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
        p{
          color: #2E7BFF;
          text-decoration: underline ;
        }
      }
    }
    .baojia{
      padding: 39px 16px 10px 16px;
      display: flex;
      justify-content: center;
      button{
        width: 167px;
        height: 44px;
        border-radius: 4px;
        font-weight: 600;
      }
      .rejust{
        background: #ECF2FF;
        border: 1px solid #2F7BFF;
        color: #2F7BFF;
        margin-right: 10px;
      }
      .submit{
        background: #2F7BFF;
        border: 1px solid #2F7BFF;
        color: #fff;
      }
    }
  }
  .dialog{
    width: 290px;
    height: 349px;
    background: #FFFFFF;
    border-radius: 8px;
    padding:16px 20px;
    .name{
      font-size: 20px;
      text-align: center;
      font-weight: 600;
      color: #333333;
      padding-bottom: 12px;
      border-bottom: 1px solid #eee;
    }
    .blue{
      font-size: 12px;
      color: #2F7BFF;
    }
    .dialog-item{
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .item-label{
        width: 60px;
        text-align: right;
        font-size: 15px;
        color: #222;
      }
      input{
        width: 160px;
        height: 28px;
        background: #F7F8FA;
        border-radius: 2px;
        border: none;
        margin-left: 5px;
        margin-right: 8px;
        padding-left: 10px;
      }
    }
    .button{
      display: flex;
      justify-content: space-between;
      padding-top: 16px;
      button{
        width: 114px;
        height: 35px;
        border-radius: 8px;
        border: none;
        color: #fff;
      }
      .cancle{
          background: #FFFFFF rgba(47, 123, 255, 0.1);
          color: #2F7BFF;
      }
      .comfirm{
        background: #2F7BFF;
      }
    }
  }
  .to-index{
      width: 122px;
      position: fixed;
      right: 10px;
      bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/view/designer/quotationTextDetail.vue